import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';
import { ADD_USER_ADDRESS, ADD_USER_ADDRESS_FAIL, ADD_USER_ADDRESS_SUCCESS } from './user-aux.actions';
import { TranslationService } from '@spartacus/core';

@Injectable()
export class UserAuxEffects {
  constructor(
    private actions$: Actions,
    private toasterService: ToasterService,
    private translationService: TranslationService,
  ) {}

  createAdddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ADD_USER_ADDRESS, ADD_USER_ADDRESS_FAIL, ADD_USER_ADDRESS_SUCCESS),
      map((action: { type: string }) => {
        if (action.type === ADD_USER_ADDRESS_FAIL) {
          this.translationService
            .translate('generic.error')
            .pipe(take(1))
            .subscribe(text => {
              this.toasterService.init({
                type: TOASTER_TYPE.DANGER,
                content: text,
              });
            });
        }

        return { type: '[Toaster] - ' + action.type };
      }),
    ),
  );
}
